/**
 * Logs strings when DEBUG env variable is set
 */
export function log(...args: any[]) {
  if (process.env.NEXT_PUBLIC_DEBUG) {
    console.log(...args)
  }
}
